import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}`;
export const brandProfile = {
    getBrandProfile,
    saveBrandProfileData,
    updateBrandProfileData,
    deleteBrandProfile,
};

function getBrandProfile() {
    return fetchWrapper.get(`${baseUrl}/me/brand-profile`);
}

function saveBrandProfileData(params) {
    return fetchWrapper.post(`${baseUrl}/me/brand-profile`,params);
}
function deleteBrandProfile(profile_id) {
  return fetchWrapper.delete(`${baseUrl}/me/brand-profile/${profile_id}`);
}

function updateBrandProfileData(profile_id, params) {
  return fetchWrapper.put(`${baseUrl}/me/brand-profile/${profile_id}`, params);
}

